// frontend/source/portal/components/EditCategoryCard.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ImagePicker from "./ImagePicker";
import "./EditCategoryCard.css";

const EditCategoryCard = ({ category, onDelete, onUpdate }) => {
  const navigate = useNavigate();
  const [isEditing, setIsEditing] = useState(false);
  const [name, setName] = useState(category.name);
  const [isSaving, setIsSaving] = useState(false);
  const [showImagePicker, setShowImagePicker] = useState(false);

  const handleSave = async () => {
    if (name.trim() === "") {
      alert("Category name cannot be empty");
      return;
    }

    if (name === category.name) {
      setIsEditing(false);
      return;
    }

    try {
      setIsSaving(true);
      await onUpdate(category._id, { name });
      setIsEditing(false);
    } catch (err) {
      setName(category.name);
    } finally {
      setIsSaving(false);
    }
  };

  const handleCancel = () => {
    setName(category.name);
    setIsEditing(false);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSave();
    } else if (e.key === "Escape") {
      handleCancel();
    }
  };

  const handleImageSelect = async (imageUrl) => {
    try {
      setIsSaving(true);
      await onUpdate(category._id, { image: imageUrl });
    } catch (err) {
      console.error("Failed to update image:", err);
    } finally {
      setIsSaving(false);
    }
  };

  const handleManageTags = () => {
    navigate(`/portal/category/${category._id}/tags`);
  };

  return (
    <div className="edit-category-card">
      <div className="edit-category-card-image-container">
        <img
          src={category.image}
          alt={category.name}
          onClick={handleManageTags}
          className="edit-category-card-image"
        />
        <button
          onClick={() => setShowImagePicker(true)}
          className="edit-category-change-image-btn"
          title="Change image"
        >
          📷
        </button>
      </div>
      <div className="edit-category-card-overlay">
        {isEditing ? (
          <div className="edit-category-input-container">
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              onKeyDown={handleKeyPress}
              className="edit-category-input"
              autoFocus
              disabled={isSaving}
            />
            <div className="edit-category-buttons">
              <button
                onClick={handleSave}
                className="edit-category-btn save-btn"
                disabled={isSaving}
              >
                {isSaving ? "Saving..." : "Save"}
              </button>
              <button
                onClick={handleCancel}
                className="edit-category-btn cancel-btn"
                disabled={isSaving}
              >
                Cancel
              </button>
            </div>
          </div>
        ) : (
          <>
            <h2 className="edit-category-card-title">{category.name}</h2>
            <div className="edit-category-actions">
              <button
                onClick={() => setIsEditing(true)}
                className="edit-category-action-btn edit-btn"
                title="Edit category name"
              >
                Edit
              </button>
              <button
                onClick={() => onDelete(category._id)}
                className="edit-category-action-btn delete-btn"
                title="Delete category"
              >
                Delete
              </button>
            </div>
          </>
        )}
      </div>

      {showImagePicker && (
        <ImagePicker
          currentImage={category.image}
          onImageSelect={handleImageSelect}
          onClose={() => setShowImagePicker(false)}
        />
      )}
    </div>
  );
};

export default EditCategoryCard;
